import {
  ADVISERS_RECEIVE_CATEGORIES,
} from '../actions';
import Api from '../../services/Api';
import {application} from '../../constants/configs';

export const receiveCategories = (categories) => ({
  type: ADVISERS_RECEIVE_CATEGORIES,
  payload: {
    categories
  }
});


function fetchCategories() {
  return async dispatch => {
    const {data: {categories}} = await Api.invoke('GET', application.coreEndpoint + '/admin/advisers/categories');
    dispatch(receiveCategories(categories));
  };
}

function shouldFetchCategories(state) {
  return !state.advisers.categories;
}

export function fetchCategoriesIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchCategories(getState())) {
      return dispatch(fetchCategories());
    }
  };
}
